import moment from 'moment'

import getValidCashflowPredictions from '../helpers/getValidCashflowPredictions'
import getValidDefaultPredictions from '../helpers/getValidDefaultPredictions'
import loan from './testData/loan'

describe('helpers', () => {
  describe('#getValidCashflowPredictions', () => {
    it('should return a list of cashflow predictions sorted by descending createdAt time', () => {
      const cashflowPredictions = loan.predictionResults.filter(result => result.predictionModel.type === 'cash_flow')
      const validPredictions = getValidCashflowPredictions(cashflowPredictions)
      let lastCreatedAt = moment(validPredictions[0].createdAt).unix()
      for (let i = 1; i < validPredictions.length; i++) {
        const result = validPredictions[i]
        const currentCreatedAt = moment(result.createdAt).unix()
        expect(currentCreatedAt).toBeLessThan(lastCreatedAt)
        lastCreatedAt = currentCreatedAt
      }
    })
    it('should return a list of cashflow predictions that all have smartRates', () => {
      const cashflowPredictions = loan.predictionResults.filter(result => result.predictionModel.type === 'cash_flow')
      const validPredictions = getValidCashflowPredictions(cashflowPredictions)
      for (const result of validPredictions) {
        expect(result.smartRate).toBeDefined()
      }
    })
  })
  describe('#getValidDefaultPredictions', () => {
    it('should returna  list of default predictions sorted by descending createdAt time', () => {
      const defaultPredictions = loan.predictionResults.filter(result => result.predictionModel.type === 'default')
      const validPredictions = getValidDefaultPredictions(defaultPredictions)
      let lastCreatedAt = moment(validPredictions[0].createdAt).unix()
      for (let i = 1; i < validPredictions.length; i++) {
        const result = validPredictions[i]
        const currentCreatedAt = moment(result.createdAt).unix()
        expect(currentCreatedAt).toBeLessThan(lastCreatedAt)
        lastCreatedAt = currentCreatedAt
      }
    })
    it('should return a list of default predictions that all have riskRatings', () => {
      const defaultPredictions = loan.predictionResults.filter(result => result.predictionModel.type === 'default')
      const validPredictions = getValidDefaultPredictions(defaultPredictions)
      for (const result of validPredictions) {
        expect(result.riskRating).toBeDefined()
      }
    })
  })
})


